import { isSupabaseConfigured, supabase } from './supabaseClient';

let activeAudio = null;
let activeUrl = null;

const stop = () => {
  window.speechSynthesis?.cancel();
  if (activeAudio) { activeAudio.pause(); activeAudio.currentTime = 0; }
  if (activeUrl) URL.revokeObjectURL(activeUrl);
  activeAudio = null; activeUrl = null;
};

const chooseVoice = () => {
  const voices = window.speechSynthesis?.getVoices?.() || [];
  const preferred = /(natural|neural|premium|enhanced|samantha|daniel|google us english)/i;
  return voices.find((voice) => /^en[-_]/i.test(voice.lang) && preferred.test(voice.name)) || voices.find((voice) => /^en[-_]/i.test(voice.lang)) || null;
};

const browserSpeak = (text, onEnd, onError) => {
  if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) throw new Error('Speech playback is not supported by this browser.');
  const utterance = new window.SpeechSynthesisUtterance(text);
  utterance.voice = chooseVoice(); utterance.rate = 0.92; utterance.pitch = 1;
  utterance.onend = onEnd; utterance.onerror = onError;
  window.speechSynthesis.speak(utterance);
};

const accessToken = async () => {
  if (!isSupabaseConfigured) throw new Error('Sign-in is not configured.');
  const { data: { session } = {}, error } = await supabase.auth.getSession();
  if (error) throw error;
  if (!session?.access_token) throw new Error('Please sign in to use speech playback.');
  return session.access_token;
};

export const playSpeech = async ({ text, onEnd, onError }) => {
  stop();
  const spokenText = String(text || '').trim();
  if (!spokenText) throw new Error('There is no text to read aloud.');
  const token = await accessToken();
  const response = await fetch('/api/tts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ text: spokenText })
  });
  if (response.status === 409) return browserSpeak(spokenText, onEnd, onError);
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || 'Speech service is temporarily unavailable.');
  }
  activeUrl = URL.createObjectURL(await response.blob());
  activeAudio = new Audio(activeUrl);
  activeAudio.onended = onEnd;
  activeAudio.onerror = onError;
  await activeAudio.play();
};

export const playVerse = ({ text, reference, onEnd, onError }) => playSpeech({
  text: `${reference}. ${text}`,
  onEnd,
  onError
});

export const stopVerse = stop;
